const RENDERER_CONFIG = {
	LIGHTS: {
		COLOR: 0xffffff,
		POS_Y: 100,
	},
	CAMERA: {
		MIN_DISTANCE: 0.5,
		MAX_DISTANCE: 5,
		DISTANCE_TICK: 0.5,
	},
	TRANSFORM_CONTROLS: {
		ROTATION_SNAP: 5,
		TRANSLATION_SNAP: 0.1,
	},
	SCREENSHOT: {
		WIDTH: 1920,
		HEIGHT: 1080,
		FLOOR_SIZE_OFFSET: 5,
	},
	CONTROLS: {
		PAN_SPEED: 0.8,
	},
	INITIAL_DISTANCE: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
	MOUSE: {},
	COLORS: {
		GREEN: 0x087f5b,
		RED: 0xc92a2a,
		CREAM: 0xde9556,
		LIGHT_CREAM: 0xf8f2e7,
		BLACK: 0x141414,
		LIGHT_GRAY: 0xf8f9fa,
	},
	ACCESSORIES: {},
} as const;

export default RENDERER_CONFIG;
